import React from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="d-flex">
              <p>44 Tara Cres,</p>
            </div>
            <div className="d-flex">
              <p>Markham ON, L3S 4S8</p>
            </div>
            <div className="d-flex">
              <a href="tel:647-309-7886">+1(647)309-7886</a>
            </div>
            <div className="d-flex">
              <a href="mailto:anujmaitri@gmail.com">anujmaitri@gmail.com</a>
            </div>
          </div>
          <div className="col-lg-3 col-md-2 col-sm-6 mt-2 mb-4">
            <div className="row">
              <div className="col">
                <Link smooth={true} className="footer-nav" href="#" to="home">
                  <a className="footer-nav">Home</a>
                </Link>
                <br />
                <Link smooth={true} className="footer-nav" href="#" to="home">
                  <a className="footer-nav">About Me</a>
                </Link>
                <br />
                <Link smooth={true} className="footer-nav" href="#" to="home">
                  <a className="footer-nav">Skills</a>
                </Link>
              </div>
              <div className="col">
                <Link smooth={true} className="footer-nav" href="#" to="home">
                  <a className="footer-nav">Education</a>
                </Link>
                <br />
                <Link smooth={true} className="footer-nav" href="#" to="home">
                  <a className="footer-nav">Experience</a>
                </Link>
                <br />
                <Link smooth={true} className="footer-nav" href="#" to="home">
                  <a className="footer-nav">Portfolio</a>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-6 align-items-center">
            <div className="d-flex justify-content-center">
              <FacebookShareButton
                url={"https://www.facebook.com/anujmaitri"}
                quote={"Web Developer Portfolio Website"}
                hashtag="#webdeveloper"
              >
                <FacebookIcon className="mx-3" size={36} />
              </FacebookShareButton>
              <FacebookMessengerShareButton
                url={"https://www.facebook.com/anujmaitri"}
                quote={"Web Developer Portfolio Website"}
                hashtag="#webdeveloper"
              >
                <FacebookMessengerIcon className="mx-3" size={36} />
              </FacebookMessengerShareButton>
              <LinkedinShareButton
                url={"https://www.facebook.com/anujmaitri"}
                quote={"Web Developer Portfolio Website"}
                hashtag="#webdeveloper"
              >
                <LinkedinIcon className="mx-3" size={36} />
              </LinkedinShareButton>
              <WhatsappShareButton
                url={"https://www.facebook.com/anujmaitri"}
                quote={"Web Developer Portfolio Website"}
                hashtag="#webdeveloper"
              >
                <WhatsappIcon className="mx-3" size={36} />
              </WhatsappShareButton>
            </div>
            <p className="pt-3 text-center">
              Copyright&copy;
              {new Date().getFullYear()}&nbsp; SiteOn | www.siteon.ca | All
              Rights Reserved{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
